import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StagesListComponent } from './stages-list/stages-list.component';
import { StagesListComponent2 } from './stages-list/stages-list.component2';
import { StageDetailComponent } from './stage-detail/stage-detail.component';
import { SharedPipeModule } from '../pipes/shared-pipe-module';

@NgModule({
  imports: [
    CommonModule,
    SharedPipeModule,
  ],
  declarations: [StagesListComponent2, StagesListComponent, StageDetailComponent],
  providers: []
})

export class StagesModule { }
